import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import VueSocketIO from 'vue-socket.io';
import SocketIO from 'socket.io-client';
import VueAppend from 'vue-append';
import store from './store';
import App from './App.vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import router from './router';
import config from './scripts/config';

Vue.use(VueAppend);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(new VueSocketIO({
  debug: false,
  connection: SocketIO(config.socketsTread),
  vuex: {
    store,
    actionPrefix: 'socket_',
    mutationPrefix: 'socket_',
  },
}));

// eslint-disable-next-line
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js